import axios from 'axios'
import emitter from '@/util/emitter.js'

const service = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  // 表示跨域请求时是否需要使用凭证
  withCredentials: true,
  timeout: 60000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // const token = localStorage.getItem("token")
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`
    // }
    const code = localStorage.getItem("code")
    if (code && code !== '') {
      config.params = config.params || {}
      config.params.code = code
    }
    return config
  },
  error => {
    emitter.emit('http-error', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 2xx 范围内的状态码都会触发该函数
    const res = response.data
    // 统一处理业务错误
    if (res.code !== 200) {
      emitter.emit('http-error', res || '请求失败')
      return Promise.reject(res)
    }
    return res
  },
  error => {
    // 超出 2xx 范围的状态码都会触发该函数
    console.error(error)
    emitter.emit('http-error', error || '请求失败')
    return Promise.reject(error)
  }
)

export default service
